import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { InternationalRequest, InternationalRequestDetail } from '../data/international-request';
import { InternationalRequestService } from '../services/international-request.service';
import { FordService } from '../services/ford.service';
import { Router } from '@angular/router';
// import { Dealer, DealerCurrent } from '../data/dealer';
import { FuncsService } from '../services/funcs.service';
import { Customer, CustomerCurrent } from '../data/customer';

import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';

interface status {
  id: number;
  name: string;
}

@Component({
  selector: 'app-request-intl',
  templateUrl: './request-intl.component.html',
  styleUrl: './request-intl.component.css',
  standalone: false
})
export class RequestIntlComponent implements OnInit, AfterViewInit {
  

  displayedColumns: string[] = ['username', 'dealer_name', 'email', 'license_qty_requested', 'request_date', 'actions'];

  public loading = "loading...";
  public f = this.funcs;
  report: InternationalRequestDetail[] = [];
  selectedStatus = 101;  
  searchText: string = '';

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  dataSource = new MatTableDataSource<InternationalRequestDetail>(this.report);

  constructor(
    private internationalRequestService: InternationalRequestService,
    private fordService: FordService,
    private router: Router,
    private funcs: FuncsService
  ) { }

  statuses: status[] = [
    { "id": 101, "name": "Submitted" },
    { "id": 201, "name": "Approved" },
    { "id": 1000, "name": "Denied" }
  ];

  changeStatus(eventEnroll: Event) {
    this.getRequests();
  }

  ngOnInit() {
    this.funcs.currentCustomer(CustomerCurrent);
    if (this.funcs.isAdminRole(CustomerCurrent.role)) {
      this.getRequests();
    }
    this.loading = "";
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  isApproved() {
    if (this.selectedStatus == 201 || this.selectedStatus == 1000) {
      return false;
    }
    return true;
  }

  approvedOrDenied() {
    if (this.selectedStatus == 201) {
      return "Approved On";
    }
    if (this.selectedStatus == 1000) {
      return "Denied On";
    }
    return "";
  }

  deny(id: number, pa_code: string) {
    if (confirm(`Deny subscription change request from ${pa_code}?`)) {
      this.internationalRequestService.denyInternationalRequest(id, CustomerCurrent.username).subscribe(report => {
        this.getRequests();
      });
    }
  }

  approve(id: number, pa_code: string, newSubs: number) {
    if (confirm(`Approve subscription change request from ${pa_code}?`)) {
      this.fordService.getSubscription(pa_code).subscribe(sub => {
        sub.maxAllowedUniqueDealerTechnicianLogins = newSubs;
        if (sub.siteCode && sub.siteCode == pa_code) {
          this.internationalRequestService.approveInternationalRequest(sub, id, CustomerCurrent.username).subscribe(report => {
            this.getRequests();
          });
        }
      });
    }
  }

  getRequests(): void {
    this.internationalRequestService.getInternationalRequestsByStatusRep(this.selectedStatus, CustomerCurrent.username).subscribe(report => {
      this.report = report;
      this.dataSource.data = this.report;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.loading = "";
    });
  }

  applyFilter(event: any) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.searchText = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  clearSearch() {
    this.searchText = '';
    this.applyFilter({ target: { value: '' } });
  }
}
